
<header [class.fill]="fill" [class.fix]="ready2">
    <h1 class="for-sreader">Essence Estoril</h1>

    <nav class="menu f-upper f-center z-medium d-flex align-center" *ngIf="ready" [class.visible]="menu" [style.top]="'calc(0rem + ' + offset + 'px)'">
        <a (click)="scrollTo($event, 'about')"><span>{{ content[language].menu.about }}</span></a>
        <a (click)="scrollTo($event, 'video')"><span>{{ content[language].menu.video }}</span></a>
        <a (click)="scrollTo($event, 'location')"><span>{{ content[language].menu.location }}</span></a>
        <a (click)="scrollTo($event, 'perspectives')"><span>{{ content[language].menu.perspectives }}</span></a>
        <a (click)="scrollTo($event, 'gallery')"><span>{{ content[language].menu.gallery }}</span></a>
        <a (click)="scrollTo($event, 'apartments')"><span>{{ content[language].menu.apartments }}</span></a>

        <span class="sep" (click)="menu = false"></span>

        <!-- <a (click)="scrollTo($event, 'members')"><span>{{ content[language].menu.members }}</span></a> -->
        <a href="https://wa.me/351913095597" *ngIf="window > 1903 " target="_blank"><span id="custom-span"><div id="icon-whats"><img id="whats-icon" src="assets/content/icon/whatsapp-01.png" alt=""></div></span></a>
        <a href="https://wa.me/351913095597" *ngIf="window < 1903 " target="_blank"><span id="custom-span"><div id="icon-whats"><img id="whats-icon" src="assets/content/icon/whatsapp-mobile.png" alt=""></div></span></a>
        <a (click)="scrollTo($event, 'logos')"><span>{{ content[language].menu.broughtBy }}</span></a>
        <a href="assets/content/brochura-essence.pdf" target="_blank"><span>{{ content[language].menu.book }}</span></a>
        <a (click)="toggleLanguage()"><span>{{ language == 'en' ? 'Português' : 'English' }}</span></a>
        <a (click)="scrollTo($event, 'contact')" *ngIf="seller"><span>{{ content[language].menu.contact }}</span></a>
    </nav>

    <div class="logo d-flex align-center justify-center z-bottom" [class.ready]="ready">
        <div class="letter e t t-slide-l-3"></div>
        <div class="letter s t t-slide-l-2"></div>
        <div class="letter s t-slide-l"></div>
        <div class="letter e t-scale"></div>
        <div class="letter n t-slide-r"></div>
        <div class="letter c t t-slide-r-2"></div>
        <div class="letter e t t-slide-r-3"></div>
    </div>
    <div class="menu-toggle" (click)="menu = true"></div>
</header>

<div class="main" *ngIf="ready" [class.menu-visible]="menu">
    <section-banner class="z-bottom"></section-banner>
    <section-about class="z-bottom"></section-about>
    <section-location id="location" class="z-bottom"></section-location>
    <section-perspectives id="perspectives" class="z-bottom"></section-perspectives>
    <section-gallery id="gallery" class="z-bottom"></section-gallery>
    <section-apartments id="apartments" class="z-medium"></section-apartments>
    <section-contact id="contact" class="z-bottom"></section-contact>
    <section-companies class="z-bottom"></section-companies>
</div>

<footer *ngIf="ready" [class.menu-visible]="menu">
    <img src="assets/images/logo.png" class="logo-footer">

    <nav class="f-upper f-light f-center">
        <a (click)="scrollTo($event, 'about')"><span>{{ content[language].menu.about }}</span></a>
        <a (click)="scrollTo($event, 'video')"><span>{{ content[language].menu.video }}</span></a>
        <a (click)="scrollTo($event, 'location')"><span>{{ content[language].menu.location }}</span></a>
        <a (click)="scrollTo($event, 'perspectives')"><span>{{ content[language].menu.perspectives }}</span></a>
        <a (click)="scrollTo($event, 'gallery')"><span>{{ content[language].menu.gallery }}</span></a>
        <a (click)="scrollTo($event, 'apartments')"><span>{{ content[language].menu.apartments }}</span></a>
        <!--a (click)="scrollTo($event, 'members')"><span>{{ content[language].menu.members }}</span></a-->
        <a (click)="scrollTo($event, 'logos')"><span>{{ content[language].menu.broughtBy }}</span></a>
        <a href="assets/content/brochura-essence.pdf" target="_blank"><span>{{ content[language].menu.book }}</span></a>
        <a (click)="toggleLanguage()"><span>{{ language == 'en' ? 'Português' : 'English' }}</span></a>
        <!--a (click)="scrollTo($event, 'contact')"><span>{{ content[language].menu.contact }}</span></a-->
    </nav>

    <p class="copy f-light f-center">
        @ Essence Estoril 2020. Todos os direitos reservados. As informações e imagens que constam neste sítio são meramente<br>
        indicativas e poderão, por motivos técnicos, comerciais ou legais, serem sujeitos a alterações ou variações.
        <!--br><br><br>
        {{ language == 'en' ? 'Terms and conditions' : 'Termos e condições' }}
        &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
        {{ language == 'en' ? 'Cookies policy' : 'Politica de cookies' }}-->
    </p>

    <div class="sign">
        Desenvolvido pela <a href="https://quantica.ag" rel="noopener" target="_blank">Quantica</a>
    </div>
</footer>
